import { render, staticRenderFns } from "./FinalPageModule.vue?vue&type=template&id=fa56c728&scoped=true&"
import script from "./FinalPageModule.vue?vue&type=script&lang=js&"
export * from "./FinalPageModule.vue?vue&type=script&lang=js&"
import style0 from "./FinalPageModule.vue?vue&type=style&index=0&id=fa56c728&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa56c728",
  null
  
)

export default component.exports